import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { DateInput } from 'foundations-components/transitional/components/DateInput';
import { TimeInput } from 'foundations-components/transitional/components/TimeInput';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDueDateValidation } from '../hooks/useDueDateValidation';
import { getDefaultTimeForDate } from '../utils/dueDate';
import { DueDateReminderTooltipContent } from './DueDateReminderTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalDueDateInputGroup = ({
  dueDate,
  setDueDate,
  dueTime,
  setDueTime,
  isDueDateValid,
  setIsDueDateValid
}) => {
  const {
    minSelectableDate,
    maxSelectableDate,
    minTimeForDate
  } = useDueDateValidation({
    dueDate,
    dueTime,
    setIsDueDateValid
  });
  const onDueDateChange = newDate => {
    // Null check is needed as the DateInput component returns null when the date is not set
    if (newDate === null) {
      setDueDate(undefined);
    } else {
      setDueDate(newDate);
      if (dueTime === undefined) {
        setDueTime(getDefaultTimeForDate(newDate));
      }
    }
  };
  const onDueTimeChange = newTime => {
    // Null check is needed as the TimeInput component returns null when the time is not set
    if (newTime === null) {
      setDueTime(undefined);
    } else {
      setDueTime(newTime);
    }
  };
  return /*#__PURE__*/_jsxs(InputGroup, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.dueDate.label"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.dueDate.help"
    }),
    tooltip: /*#__PURE__*/_jsx(DueDateReminderTooltipContent, {}),
    validationMessage: !isDueDateValid && (!dueDate || dueTime === undefined ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.dueDate.error.noDueDateAndTime"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.dueDate.error.pastDateTime"
    })),
    error: !isDueDateValid,
    children: [/*#__PURE__*/_jsx(FormControl, {
      "aria-label": unescapedText('productApprovals.dueDate.dateAriaLabel'),
      children: /*#__PURE__*/_jsx(DateInput, {
        "data-test-id": "approval-due-date-input",
        value: dueDate,
        onChange: evt => onDueDateChange(evt.target.value),
        min: minSelectableDate,
        max: maxSelectableDate,
        error: !isDueDateValid
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      "aria-label": unescapedText('productApprovals.dueDate.timeAriaLabel'),
      children: /*#__PURE__*/_jsx(TimeInput, {
        "data-test-id": "approval-due-time-input",
        value: dueTime,
        onChange: evt => onDueTimeChange(evt.target.value),
        min: minTimeForDate,
        error: !isDueDateValid,
        format: `LT [${I18n.moment.portalTz().format('z')}]`
      })
    })]
  });
};